import { useMemo, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import { SeasonLink as Link } from "../../components/Seasons/SeasonLink";
import './AuthPage.css';
import eyeclosed from '../../assets/icons/eyeclosed.svg';
import eyeopen from '../../assets/icons/eye.svg';
import { resetPassword } from '../../api/auth';
import { validatePassword, validatePasswordConfirm } from '../../utils/validators';

export function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => (searchParams.get('token') || '').trim(), [searchParams]);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isResetCompleted, setIsResetCompleted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    if (!token) {
      setError('Токен сброса не найден в ссылке.');
      return;
    }
    const passwordError = validatePassword(password);
    const confirmError = validatePasswordConfirm(password, confirmPassword);
    if (passwordError || confirmError) {
      setError(passwordError || confirmError);
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await resetPassword(token, password);
      setMessage(response?.detail || 'Пароль принят. Теперь можно войти в аккаунт.');
      setIsResetCompleted(true);
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.message || 'Не удалось обновить пароль.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form-container" style={{ flex: 1 }}>
        <div className="auth-card">
          <h1 className="auth-title">{isResetCompleted ? 'Пароль обновлен' : 'Новый пароль'}</h1>
          {isResetCompleted ? (
            <div className="auth-form">
              <p className="auth-link">{message || 'Пароль принят. Теперь можно войти в аккаунт.'}</p>
              <Link to="/login" className="auth-button" style={{ textAlign: 'center', textDecoration: 'none' }}>
                Перейти ко входу
              </Link>
            </div>
          ) : (
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label" htmlFor="reset-password">Пароль</label>
                <div className="password-input-wrapper">
                  <input
                    id="reset-password"
                    className="form-input"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    placeholder="Введите новый пароль"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword((prev) => !prev)}
                    tabIndex={-1}
                  >
                    <img src={showPassword ? eyeopen : eyeclosed} alt="" />
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="reset-password-confirm">Повторите пароль</label>
                <div className="password-input-wrapper">
                  <input
                    id="reset-password-confirm"
                    className="form-input"
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={(event) => setConfirmPassword(event.target.value)}
                    placeholder="Повторите новый пароль"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                    tabIndex={-1}
                  >
                    <img src={showConfirmPassword ? eyeopen : eyeclosed} alt="" />
                  </button>
                </div>
              </div>
              <button type="submit" className="auth-button" disabled={isSubmitting}>
                {isSubmitting ? 'Сохраняем...' : 'Сменить пароль'}
              </button>
            </form>
          )}
          {error ? <p className="auth-link" style={{ color: '#cf2f4d' }}>{error}</p> : null}
          {!isResetCompleted ? (
            <p className="auth-link">
              <Link to="/login" className="auth-link-register">Перейти ко входу</Link>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
